import { render, staticRenderFns } from "./ControlesMapa.vue?vue&type=template&id=10b8acbb&scoped=true&"
import script from "./ControlesMapa.vue?vue&type=script&lang=js&"
export * from "./ControlesMapa.vue?vue&type=script&lang=js&"
import style0 from "./ControlesMapa.vue?vue&type=style&index=0&id=10b8acbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8acbb",
  null
  
)

export default component.exports